import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle, withState } from 'recompose'
import { reduxForm, getFormValues, Field, reset } from 'redux-form'
import { Confirm, Modal, Button } from 'semantic-ui-react'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { Cont, ModalAction } from './styled'
import { createRole, updateRole } from 'ducks/roleMan'

import r from 'reactotron-react-js'

import { Toaster } from '@blueprintjs/core'
let toast = Toaster.create({ message: '', show: false })

const RoleModal = props => {
  const {
    handleSubmit,
    data,
    valueForm,
    show,
    title,
    changeShow,
    showConfirm,
    setShowConfirm,
  } = props
  const onDataCreated = (pageSize, setCurrentPage) => itemCount => {
    r.log({ pageSize, setCurrentPage, itemCount })
    if (itemCount <= pageSize) {
      setCurrentPage(0)
    } else {
      let targetPage = Math.ceil(itemCount / pageSize)
      setCurrentPage(targetPage - 1)
    }
  }
  return (
    <div>
      <Modal
        size="tiny"
        open={show}
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Modal.Header>{title || ''}</Modal.Header>
        <Modal.Content>
          <form onSubmit={handleSubmit(() => setShowConfirm(true))}>
            <Cont>
              {!props.isCreate && (
                <div className="subCont">
                  <Field
                    name="active"
                    label="Active"
                    type={type.checkbox}
                    component={FieldInput}
                  />
                </div>
              )}
              <div className="subCont">
                <Field
                  label="Role Name"
                  name="name"
                  placeholder={''}
                  component={FieldInput}
                  require
                />
              </div>
              <div className="subCont ui form">
                <Field
                  label="Role Description"
                  name="description"
                  placeholder={''}
                  type={type.textArea}
                  component={FieldInput}
                  require
                />
              </div>
            </Cont>
            <ModalAction>
              <Button onClick={() => closeModal()} negative>
                Cancel
              </Button>
              <Button
                type="submit"
                positive
                labelPosition="right"
                icon="save"
                content="Save"
              />
            </ModalAction>
          </form>
        </Modal.Content>
      </Modal>
      <Confirm
        size="mini"
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onConfirm={() => submitModal()}
      />
    </div>
  )

  function submitModal() {
    setShowConfirm(false)
    if (props.isCreate) {
      let hasRole = props.roles.find(
        item => item.name.toUpperCase() === valueForm.name.toUpperCase()
      )
      if (hasRole) {
        toast.clear()
        toast.show({
          message: hasRole.name + ' was already',
          intent: 'warning',
          timeout: 5000,
        })
        closeModal()
      } else {
        props.createRole(
          {
            name: valueForm.name,
            description: valueForm.description,
            isActive: true,
          },
          closeModal,
          onDataCreated(props.tablePageSize, props.setCurrentPage)
        )
      }
    } else {
      let hasRole = props.roles.find(item => item.name.toUpperCase() === valueForm.name.toUpperCase())
      let hasRoleId = props.roles.find(item => item.id === data.id)
      if (hasRole) {
        if (hasRole === hasRoleId) {
          props.updateRole(
            {
              id: data.id,
              name: valueForm.name,
              description: valueForm.description,
              isActive: valueForm.active,
            },
            closeModal,
            onDataCreated(props.tablePageSize, props.setCurrentPage)
          )
        } else {
          toast.clear()
          toast.show({
            message: hasRole.name + ' was already',
            intent: 'warning',
            timeout: 5000,
          })
          closeModal()
        }
      } else {
        props.updateRole(
          {
            id: data.id,
            name: valueForm.name,
            description: valueForm.description,
            isActive: valueForm.active,
          },
          closeModal,
          onDataCreated(props.tablePageSize, props.setCurrentPage)
        )
      }
    }
  }

  function closeModal() {
    changeShow()
    props.dispatch(reset('formRoleModal'))
  }
}

const validate = values => {
  const errors = {}
  if (!values.name) {
    errors.name = 'Required!'
  }
  if (!values.description) {
    errors.description = 'Required!'
  }

  return errors
}

const mapStateToProps = (state, props) => {
  return {
    initialValues: {
      name: props.data ? props.data.name : '',
      description: props.data ? props.data.description : '',
      active: props.data ? props.data.active : true,
    },
    valueForm: getFormValues('formRoleModal')(state),
    roles: state.roleMan.roles,
  }
}

const mapDispatchToProps = {
  createRole,
  updateRole,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'formRoleModal',
    validate: validate,
    enableReinitialize: true,
  }),
  withState('showConfirm', 'setShowConfirm', false),
  lifecycle({
    componentDidMount() {},
    componentWillReceiveProps(nextProp) {},
  })
)

export default enhance(RoleModal)
